/* AITO — exit survey.
   Split out of aito.js: this is store-specific marketing behaviour, not theme
   behaviour, so it should not sit in the bundle every page load pays for. The
   layout renders the tag only when the setting is on, which means a shop that
   does not use it downloads nothing. */
(function () {
  "use strict";

  /* aito.js owns the shared live region; this file is standalone, so it keeps a
     small one of its own rather than reaching across a bundle boundary. */
  var liveRegion;
  function announce(msg) {
    if (!liveRegion) {
      liveRegion = document.createElement("div");
      liveRegion.className = "visually-hidden";
      liveRegion.setAttribute("aria-live", "polite");
      liveRegion.setAttribute("role", "status");
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = "";
    window.setTimeout(function () { liveRegion.textContent = msg; }, 50);
  }

  /* ---------------- exit survey (p12-20260824) ----------------
     The audit fixed what could be measured on the page. This is the only thing
     that asks a person why they left. It stays out of the way of anyone who is
     actually shopping: never over the cart, search or a modal, never to someone
     who already has something in their bag, and never twice. */
  function initExitSurvey() {
    var box = document.getElementById("ExitSurvey");
    if (!box) return;
    var KEY = "aito:xsv";
    try { if (sessionStorage.getItem(KEY)) return; } catch (e) { /* private mode */ }
  
    var shown = false;
    var armedAt = Date.now() + (parseInt(box.dataset.delay, 10) || 45) * 1000;
  
    function busy() {
      return document.body.classList.contains("cart-open") ||
             document.body.classList.contains("menu-open") ||
             document.body.classList.contains("modal-open") ||
             document.body.classList.contains("search-open");
    }
    function hasBag() {
      var b = document.querySelector(".bag-count");
      return !!(b && !/\b0\b/.test(b.textContent));
    }
    function remember() { try { sessionStorage.setItem(KEY, "1"); } catch (e) {} }
  
    function show() {
      if (shown || Date.now() < armedAt || busy() || hasBag()) return;
      shown = true; remember();
      box.hidden = false;
      /* Not requestAnimationFrame: exit intent can coincide with the tab going
         to the background, where rAF never fires. The panel would then sit at
         opacity 0 with its once-per-session flag already spent — present but
         invisible. Forcing reflow gives the transition a start value, and a
         timer opens it whether or not the tab is compositing. */
      void box.offsetHeight;
      window.setTimeout(function () { box.classList.add("open"); }, 20);
      announce("one quick question before you go");
    }
    function hide() {
      box.classList.remove("open"); remember();
      window.setTimeout(function () { box.hidden = true; }, 350);
    }
  
    box.querySelectorAll("[data-xsv-close]").forEach(function (b) { b.addEventListener("click", hide); });
    window.addEventListener("keydown", function (e) { if (e.key === "Escape" && !box.hidden) hide(); });
  
    /* Copy the answer into the field Shopify actually mails, and refuse to send
       an empty one -- a blank contact email teaches the merchant nothing. */
    var form = box.querySelector("form");
    if (form) form.addEventListener("submit", function (e) {
      var txt = box.querySelector("[data-xsv-text]");
      var body = box.querySelector("[data-xsv-body]");
      var val = txt && txt.value.trim();
      if (!val) { e.preventDefault(); if (txt) txt.focus(); return; }
      if (body) body.value = val + "\n\n— exit survey, " + location.pathname;
      remember();
      /* AJAX the send: the native POST reloaded the whole page on a visitor who
         was already leaving, and the thank-you branch rendered into a hidden,
         already-spent panel no one could ever see. No fetch → native POST. */
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      fetch(form.getAttribute("action") || "/contact", { method: "POST", body: new FormData(form), headers: { "Accept": "text/html" } })
        .catch(function () { /* the answer is best-effort — never punish the visitor */ })
        .then(function () {
          form.innerHTML = '<p class="xsv-thanks" role="status">thank you — that genuinely helps.</p>';
          announce("thank you — that genuinely helps");
          window.setTimeout(hide, 2600);
        });
    });
  
    /* Desktop: the pointer leaving through the top of the window. */
    document.addEventListener("mouseout", function (e) {
      if (!e.relatedTarget && e.clientY <= 0) show();
    });
    /* Touch has no exit intent, so use the two signals that stand in for it:
       a decisive upward flick near the top, or a long read with no bag. */
    var lastY = 0;
    window.addEventListener("scroll", function () {
      var y = window.scrollY;
      if (lastY - y > 90 && y < 700) show();
      lastY = y;
    }, { passive: true });
    window.setTimeout(function () {
      var seen = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
      if (seen > 0.55) show();
    }, (parseInt(box.dataset.delay, 10) || 45) * 1000 + 5000);
  }

  function boot() {
    try { initExitSurvey(); }
    catch (err) { if (window.console && console.error) console.error("aito exit survey failed:", err); }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
